// Utility to format customer address for display
import { isNotEmpty } from './displayUtils';

export function formatCustomerAddress(customer) {
  if (!customer) return '';
  const parts = [];

  // Name
  if (isNotEmpty(customer.firstName) || isNotEmpty(customer.description)) {
    parts.push(`${customer.firstName || ''} ${customer.description || ''}`.trim());
  }
  // Street
  if (isNotEmpty(customer.street)) {
    parts.push(customer.street);
  }

  // Country, zip, city
  let location = '';
  if (isNotEmpty(customer.country)) {
    location += customer.country;
    if (isNotEmpty(customer.zipCode) || isNotEmpty(customer.city)) {
      location += '-';
    }
  }
  if (isNotEmpty(customer.zipCode) || isNotEmpty(customer.city)) {
    location += `${customer.zipCode || ''} ${customer.city || ''}`.trim();
  }
  if (location) {
    parts.push(location);
  }

  // Email
  if (isNotEmpty(customer.email)) {
    parts.push(customer.email);
  }

  return parts.join('<br/>');
}
